import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Mail } from 'lucide-react';
export function BrandBanner() {
  return <section className="pt-8 pb-16 relative" data-id="element-53">
      <div className="container mx-auto px-6 relative z-10" data-id="element-54">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-55">
          <img src="https://cdn.magicpatterns.com/uploads/bGpTZfUJ31QUjcF1cyWJRV/LOGO_LIBRO_FY.png" alt="Librofy — Compra Inteligente" className="w-[420px] md:w-[600px] lg:w-[760px] max-w-full h-auto -mb-12 md:-mb-24 lg:-mb-32 drop-shadow-[0_25px_60px_rgba(255,140,0,0.4)]" data-id="element-56" />
          <p className="relative z-10 text-gray-400 text-sm md:text-base font-medium tracking-wide" data-id="element-57">
            Contenido profesional <span className="text-gray-600 mx-1" data-id="element-58">|</span>{' '}
            Derechos reservados
          </p>
        </motion.div>

        {/* Contact block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} className="mt-3 text-center" data-id="element-59">
          <p className="text-gray-300 text-base md:text-lg mb-3" data-id="element-60">
            ✨ Consultanos sin compromiso. Respondemos tus mensajes en pocos
            minutos.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6" data-id="element-61">
            <a href="https://instagram.com/librofy.online" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm" data-id="element-62">
              <Instagram className="w-4 h-4" data-id="element-63" />
              <span data-id="element-64">@librofy.online</span>
            </a>

            <span className="hidden sm:block text-gray-700" data-id="element-65">|</span>

            <a href="mailto:soportelibrofy@gmail.com" className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm" data-id="element-66">
              <Mail className="w-4 h-4" data-id="element-67" />
              <span data-id="element-68">soportelibrofy@gmail.com</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}